import { FormikHelpers } from "formik";

import { useContext } from "react";
import { SydFilterContext } from "src/components/Common/UI/SydFilter/SydFilterContext";
import { isTypeOfDCompanySearchForm } from "src/components/Common/UI/SydFilter/SydFilterTypeChecker";
import DCompanySearchForm from "./DCompanySearchForm";


const emptyDCompanySearchForm: IDCompanySearchForm = {
  description: "",
  sapCode: "",
  unID: "",
  deleted: "",
  placeID: ""
};

const SearchDCompany = ()  => {
  const sydFilterCtx = useContext(SydFilterContext);

  const activeFilters = sydFilterCtx.activeFilters;
  const clearForm = sydFilterCtx.clearAllFilters;
  const saveFilters  = sydFilterCtx.saveFilters;
  const handleClose = sydFilterCtx.toggleFilterVisibility;

  const initialValues = isTypeOfDCompanySearchForm(activeFilters) ? activeFilters as IDCompanySearchForm : emptyDCompanySearchForm;

  const handleSubmit = async (values: IDCompanySearchForm, { setSubmitting }: FormikHelpers<IDCompanySearchForm>): Promise<void> => {
    saveFilters(values);
    setSubmitting(false);
    handleClose();
  }

  return (
    <DCompanySearchForm initialValues={initialValues} onSubmit={handleSubmit} onClearForm={clearForm} />
  )
}


export default SearchDCompany;